<template>
  <vue-element-loading
    class="loader"
    data-cy="loader"
    :active="!!isLoading"
    :spinner="spinnerType"
    :duration="duration"
    :size="size"
    :color="color"
    :is-full-screen="fullScreen"
    :background-color="backgroundColor"
  />
</template>

<script setup lang="ts">
import VueElementLoading from "vue-element-loading";

import { LOADER_DURATION, LOADER_SPINNER_TYPE } from "@/helpers/constants";

defineProps({
  isLoading: {
    type: [Boolean, Number],
    required: true,
  },
  size: {
    type: String,
    default: "40",
  },
  spinnerType: {
    type: String,
    default: LOADER_SPINNER_TYPE,
  },
  duration: {
    type: String,
    default: LOADER_DURATION,
  },
  color: {
    type: String,
    default: "#00FF72",
  },
  fullScreen: {
    type: Boolean,
    default: false,
  },
  zIndex: {
    type: Number,
    default: 100,
  },
  backgroundColor: {
    type: String,
    default: "white",
  },
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.loader {
  z-index: v-bind(zIndex) !important;
}
</style>
